// Content for Śrīmad-Bhāgavatam 2.1.11 commentary topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 2.1.11',
        sloka: `etan nirvidyamānānām
icchatām akuto-bhayam |
yogināṁ nṛpa nirṇītaṁ
harer nāmānukīrtanam ||`,
        translation:
            'O King (<strong>nṛpa</strong>)! Continuous chanting of the name of the Lord (<strong>harer nāmānukīrtanam</strong>) has been prescribed (<strong>nirṇītam</strong>) for devotees (<strong>nirvidyamānānām</strong>), for those with desires for liberation and material elevation (<strong>icchatām</strong>), and for those satisfied with the self (<strong>yoginām</strong>).',
    },
    blocks: [
        {
            type: 'dialogue',
            objection:
                '“It is understood that in this scripture bhakti is described. Among the aṅgas of bhakti which one is defined as the chief one, standing out like an emperor exerting power everywhere?”',
            response: 'This verse answers.',
        },
        {
            type: 'text',
            content:
                'Among the aṅgas of bhakti, hearing, chanting and remembering are the three chief ones. This has been stated in verse 2.1.5.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 2.1.5',
                sloka: `tasmād bhārata sarvātmā
bhagavān īśvaro hariḥ |
śrotavyaḥ kīrtitavyaś ca
smartavyaś cecchatābhayam ||`,
                translation:
                    'The Lord who is Paramātmā, Bhagavān and Lord of power, should be heard about, glorified and remembered by those desiring freedom from fear.',
            },
        },
        {
            type: 'text',
            content:
                'Among those three, chanting is the chief. In chanting, however, there is chanting of the Lord’s name, his qualities and his pastimes.<br /><br /><strong>Among those <em>anukīrtana</em> is best. That means chanting the name according to (<em>anu</em>) one’s bhakti. Or it means continuous chanting.</strong>',
        },
        {
            type: 'text',
            content:
                'It is defined (<em>nīrṇitam</em>) by the previous ācāryas, not just by me. Therefore there is no need of inquiry for proof.<br /><br /><strong>In chanting there is no fear of purity or impurity concerning time, place, person and utensils. This means that even outcastes who cannot tolerate serving the Lord do not hesitate to chant.</strong><br /><br />(Since even impure persons are allowed to chant) Moreover, there is no good, better and best for sādhakas and siddhas.',
        },
        {
            type: 'text',
            content:
                'Chanting is for those who are indifferent to all desires including the desire for liberation (<em>nirvidyāmānānām</em>). It is for those who desire material things (<em>icchatām</em>). Such persons can chant just as they make offerings for certain goals. Thus the meaning is as follows.<br /><br /><strong>It is recommended for the unalloyed devotees (<em>nirvidyamānānām</em>), for those who desire Svarga and liberation, and for those who are satisfied in the self (<em>yoginām</em>).</strong><br /><br />This means that according to these different methods one will get corresponding results (not the same result).',
        },
    ],
};

export default content;
